import FastImage from 'react-native-fast-image';
import Modal from 'react-native-modal';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;

export const Content = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(24)}px;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

export const Title = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
`;
export const Description = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  text-align: center;
`;

export const ModalFooter = styled.View`
  margin-top: ${RFValue(12)}px;
  width: 100%;
`;

export const ModalHeader = styled.View`
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(12)}px;
`;
export const AvatarContainer = styled(FastImage)`
  width: ${RFValue(60)}px;
  height: ${RFValue(60)}px;
  border-radius: ${RFValue(40)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  margin-bottom: ${RFValue(6)}px;
`;
export const AvatarName = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  text-transform: capitalize;
`;
export const AvatarStation = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: ${RFValue(12)}px;
`;
export const ModalForm = styled.View`
  width: 100%;
  margin-top: ${RFValue(12)}px;
`;

export const CloseIconButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(12)}px;
  right: ${RFValue(12)}px;
  z-index: 2;
`;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
`;
